'use strict';

module.exports = require('./src/js/adaptor/jquery');



//////////////////
// WEBPACK FOOTER
// ./~/perfect-scrollbar/jquery.js
// module id = 203
// module chunks = 35